import calendar from '@/i18n/locales/calendar/ru';
import common from '@/i18n/locales/common/ru';
import errors from '@/i18n/locales/errors/ru';
import help from '@/i18n/locales/help/ru';
import home from '@/i18n/locales/home/ru';
import layout from '@/i18n/locales/layout/ru';
import leads from '@/i18n/locales/leads/ru';
import report from '@/i18n/locales/report/ru';

export default {
    calendar,
    common,
    errors,
    help,
    home,
    layout,
    leads,
    report,
};
